import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { expensasApi } from '../../../lib/api';
import PeriodoDetalle from '../ExpensasPeriodoDetalle';

const hoyMes = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

export default function TabPeriodos({ edificioId, registerHeader }) {
  const [mes, setMes] = useState(hoyMes());
  const [periodoActual, setPeriodoActual] = useState(null);
  const [loadingPeriodo, setLoadingPeriodo] = useState(false);

  // Cuando cambia el mes, traemos (o creamos) el período correspondiente
  useEffect(() => {
    let cancelled = false;
    setLoadingPeriodo(true);
    setPeriodoActual(null);
    (async () => {
      try {
        const r = await expensasApi.getOrCreatePeriodoPorMes(edificioId, mes);
        if (!cancelled) setPeriodoActual(r.data);
      } catch (e) {
        if (!cancelled) toast.error(e.response?.data?.detail || 'Error al obtener período');
      } finally {
        if (!cancelled) setLoadingPeriodo(false);
      }
    })();
    return () => { cancelled = true; };
  }, [edificioId, mes]);

  // Sin selector en el header de la tab principal (lo movemos a la línea de KPIs)
  useEffect(() => {
    if (!registerHeader) return;
    registerHeader(null);
    return () => registerHeader(null);
  }, [registerHeader]);

  if (loadingPeriodo || !periodoActual) {
    return <div className="py-10 flex justify-center"><Loader2 className="w-5 h-5 animate-spin text-slate-400" /></div>;
  }

  return (
    <PeriodoDetalle
      edificioId={edificioId}
      periodoId={periodoActual.periodo_id}
      mes={mes}
      onMesChange={setMes}
    />
  );
}
